module.exports = __webpack_public_path__ + "fonts/Inter-700-greek-ext45.318d4ba.woff2";